import MicrophoneStream from "microphone-stream";

// Reduce chunk size significantly - AWS Transcribe works better with smaller chunks
export const MAX_AUDIO_CHUNK_SIZE = 1024 * 8; // 8KB chunks

export const pcmEncodeChunk = (chunk: any): Uint8Array => {
  const input = MicrophoneStream.toRaw(chunk);
  let offset = 0;
  const buffer = new ArrayBuffer(input.length * 2);
  const view = new DataView(buffer);

  for (let i = 0; i < input.length; i++, offset += 2) {
    const s = Math.max(-1, Math.min(1, input[i]));
    view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
  }

  // Return Uint8Array instead of Buffer
  return new Uint8Array(buffer);
};
